import script from "./ImportKaigoNoMori.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportKaigoNoMori.vue?vue&type=script&setup=true&lang=js"

import "./ImportKaigoNoMori.vue?vue&type=style&index=0&id=2f8a6ab5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f8a6ab5"]])

export default __exports__